const MULTI_COMPANY_ERROR_STATE_KEY = 'MULTI_COMPANY_ERROR_STATE';
export const MULTI_COMPANY_ERROR_STATE_EVENT =
  'multi-company-error-state-change';

export const setMultiCompanyErrorState = (): void => {
  sessionStorage.setItem(MULTI_COMPANY_ERROR_STATE_KEY, 'true');
  window.dispatchEvent(new Event(MULTI_COMPANY_ERROR_STATE_EVENT));
};

export const clearMultiCompanyErrorState = (): void => {
  sessionStorage.removeItem(MULTI_COMPANY_ERROR_STATE_KEY);
  window.dispatchEvent(new Event(MULTI_COMPANY_ERROR_STATE_EVENT));
};

export const getMultiCompanyErrorState = (): boolean =>
  sessionStorage.getItem(MULTI_COMPANY_ERROR_STATE_KEY) === 'true';
